import React from 'react';

const VARIANT_CLASS = {
  h1: 'ca-h1',
  h2: 'ca-h2',
  body: 'ca-body',
  label: 'ca-label',
  value: 'ca-value',
  small: 'ca-small',
  link: 'ca-link',
};

const VARIANT_TAG = {
  h1: 'h1',
  h2: 'h2',
  body: 'p',
  label: 'span',
  value: 'span',
  small: 'span',
  link: 'button',
};

/**
 * Typography atom — shared text styles across the package.
 */
export default function Typography({
  variant = 'body',
  as,
  className = '',
  children,
  ...props
}) {
  const Tag = as || VARIANT_TAG[variant] || 'p';
  const baseClass = VARIANT_CLASS[variant] || VARIANT_CLASS.body;

  return (
    <Tag className={`${baseClass} ${className}`.trim()} {...props}>
      {children}
    </Tag>
  );
}

export function Heading1(props) {
  return <Typography variant="h1" {...props} />;
}

export function Heading2(props) {
  return <Typography variant="h2" {...props} />;
}

export function BodyText(props) {
  return <Typography variant="body" {...props} />;
}

export function LabelText(props) {
  return <Typography variant="label" {...props} />;
}

export function ValueText(props) {
  return <Typography variant="value" {...props} />;
}

export function LinkText(props) {
  return <Typography variant="link" type="button" {...props} />;
}
